import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Fee history section permission.
 * Which users are allowed to view fee history tab on Billing page?
 */
export const FEE_HISTORY_SECTION: PermissionSet = {
  access: AccessPermissions.protected,
  includeAny: [Role.BURN_FEE_HISTORY_ROLE],
}
